import { render, staticRenderFns } from "./FantasyMnemonicDetail.vue?vue&type=template&id=276251e6&scoped=true&"
import script from "./FantasyMnemonicDetail.vue?vue&type=script&lang=js&"
export * from "./FantasyMnemonicDetail.vue?vue&type=script&lang=js&"
import style0 from "./FantasyMnemonicDetail.vue?vue&type=style&index=0&id=276251e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276251e6",
  null
  
)

export default component.exports